import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  setSearchValue,
  setOnlyMyDocs,
  toggleFilter,
  resetFilters,
} from '@/store/slices/filesSlice';
import type { FileFilters } from '../types/file.types';

export const useFilesFilters = () => {
  const dispatch = useAppDispatch();
  const { searchValue, onlyMyDocs, filters } = useAppSelector((state) => state.files);

  const handleSetSearchValue = (value: string) => {
    dispatch(setSearchValue(value));
  };

  const handleSetOnlyMyDocs = (value: boolean) => {
    dispatch(setOnlyMyDocs(value));
  };

  const handleToggleFilter = (filter: FileFilters) => {
    dispatch(toggleFilter(filter));
  };

  const handleResetFilters = () => {
    dispatch(resetFilters());
  };

  return {
    searchValue,
    onlyMyDocs,
    filters,
    setSearchValue: handleSetSearchValue,
    setOnlyMyDocs: handleSetOnlyMyDocs,
    toggleFilter: handleToggleFilter,
    resetFilters: handleResetFilters,
  };
};
